module.exports = __webpack_public_path__ + "img/pay.d927900e.png";